import React from 'react'
import {
  Dialog,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  Box,
} from '@material-ui/core'
import { FullscreenExit as FullscreenExitIcon } from '@material-ui/icons'

import { FlowchartContainer } from '../components'

import useStyles from '../styles'

const FlowchartFullscreenDialog = ({
  open,
  onClose,
  title,
  elementsByLevel,
}) => {
  const classes = useStyles()

  return (
    <Dialog open={open} onClose={onClose} maxWidth={false} fullWidth fullScreen>
      <DialogActions className={classes.dialogAction}>
        <Typography variant="h6">{title} - Tela Cheia</Typography>
        <IconButton onClick={onClose} size="small">
          <FullscreenExitIcon />
        </IconButton>
      </DialogActions>
      <DialogContent className={classes.dialogContent}>
        <Box className={classes.dialogChildren}>
          <FlowchartContainer
            elementsByLevel={elementsByLevel}
            isFullscreenMode
          />
        </Box>
      </DialogContent>
    </Dialog>
  )
}

export default FlowchartFullscreenDialog
